import React, {useContext} from "react";
import {Typography, Space, Button} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import "./style.scss";
//images
import errorImg from "../../../images/empty-result.svg";
// core
import {InterceptorContext, LayoutContext, ModalContext} from "../../../core/Contexts";

export default React.memo(function ErrorPassportAdd({title, customError, message}: IProps) {
    const context = useContext(InterceptorContext);
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);
    const {t} = useTranslation();

    const onClose = () => {
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
    };

    const titleNew = title ?? t("Что-то пошло \nне так");

    return (
        <Typography as="div" className="bl-error">
            <Space size={16} direction="vertical" align="center">
                <img alt="" src={errorImg} width={89} />
                <Typography
                    size={_.gte(contextLayout?.width ?? 0, 768) ? 36 : 36}
                    className="title"
                >
                    {titleNew}
                </Typography>
                <Typography as="div" size={14} color="#fff" className="subtitle">
                    {message
                        ? message
                        : _.chain(
                              _.isArray(context?.data)
                                  ? context?.data
                                  : context?.data?.message
                                  ? [
                                        {
                                            message: context?.data?.message,
                                            field: context?.data?.message
                                        }
                                    ]
                                  : []
                          )
                              .map(({field, message}) => (
                                  <Typography key={field} className="description" color="#fff">
                                      {t(message)}
                                  </Typography>
                              ))
                              .valueOf()}
                </Typography>
                {customError && (
                    <Typography size={14} color="#000000" fontFamily="hauss" className="subtitle">
                        {customError}
                    </Typography>
                )}
                <Button type="primary" onClick={onClose}>
                    Повторить попытку
                </Button>
            </Space>
        </Typography>
    );
});

interface IProps {
    title?: JSX.Element | string;
    customError?: string;
    message?: JSX.Element | string;
}
